<template>
  <div class="app flex-row align-items-center login-view">
    <div class="container">
      <b-row class="justify-content-center">
        <!-- <b-col md="4">
          <img class="p-4" src="img/sap-logo.jpg" style="width: 100%;" alt="SAP Logo">
        </b-col> -->
      </b-row>
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-model="username"  type="text" class="form-control" placeholder="Username" autocomplete="username email" required autofocus />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-model="password" type="password" class="form-control" placeholder="Password" autocomplete="current-password" @keyup.enter.native="login" required />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click="login" @keyup.enter="login">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" @click="showPasswordResetModal" class="px-0">Forgot password?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
                <b-row>
                  <b-col class="text-center">
                    <p></p>
                    <hr />
                    <small>(Version: {{appVersion}})</small>
                    <p>
                      Telephone: <Strong>{{settingsPhone}}</Strong><br>
                      Email: <strong>{{settingsEmail}}</strong>
                    </p>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <!-- <b-card no-body class="bg-SAP py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <div class="app-title">
                    <img src="img/pp-icon-login.png" />
                    <h2>rintPlate</h2>
                  </div>
                  <p>
                    Software by: <strong>Sandhurst Autoprint Ltd</strong>
                    <br>
                    <small>(Version 1.1.2 - T)</small>
                  </p>
                  <hr>
                  <p>
                    Telephone: <Strong>{{settingsPhone}}</Strong><br>
                    Email: <strong>{{settingsEmail}}</strong>
                  </p>
                </div>
              </b-card-body>
            </b-card> -->
          </b-card-group>
          <b-alert class="mt-2" v-if="loginError" variant="danger" show><strong>There was a problem logging in. Please ensure the username and password are correct. If the problem persists, please contact the system administrator.</strong></b-alert>
        </b-col>
      </b-row>
    </div>
    <b-modal
      title="Print Plate"
      class="modal-warning"
      v-model="activeStateForgottenPassword"
      hide-footer
    >
      <div class="form-container">
        <b-row>
          <b-col>
            <b-form-group>
              <div style="text-align: center;">
              <h4>You must have your password reset by a system administrator.</h4>
              </div>
            </b-form-group>
            <b-row>
              <b-col>
              <p>
                <strong>Please contact the system administrators through one of the following options:</strong>
              </p>
              <p>
                Email: <strong>{{settingsEmail}}</strong>
                <br />
                Telephone: <strong>{{settingsPhone}}</strong>
              </p>
              </b-col>
            </b-row>
            <div slot="modal-footer" class="w-100">
              <b-button
                size="sm"
                class="float-right"
                @click="closePasswordResetModal"
              >Okay</b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <img class="logo-overlay" src="/img/portal-logo-overlay.png" />
  </div>
</template>

<script>

import { storeController } from '../../shared/store';

export default {
  name: 'Login',
  data() {
    return {
      // username: "sapadmin@sandhurstautoprint.co.uk",
      // password: "Printplate2021",
      username: "",
      password: "",
      activeStateForgottenPassword: false,
      settingsEmail: '',
      settingsPhone: '',
      loginError: false,
      appVersion: ''
    }
  },
  created() {
    // clear any user info
    localStorage.removeItem('user');
    this.getGlobalSettings();
    this.$data.appVersion = process.env.VUE_APP_VERSION;
    console.log('IS TEST: ', process.env.VUE_APP_IS_TEST);
    if (process.env.VUE_APP_IS_TEST == 'true') {
      this.$data.appVersion += ' - T';
    }
  },
  methods : {
    login(e) {
      e.preventDefault();
      this.$data.loginError = false;
      if (this.password.length > 0) {
        const body = {
          email: this.username,
          password: this.password,
          pushToken: ""
        };
        this.$http.post("login", body)
          .then((response) => {
            const userObj = {
              id: response.data.user.id,
              first_name: response.data.user.first_name,
              last_name: response.data.user.last_name,
              email: response.data.user.email,
              telephone: response.data.user.telephone,
              approved: response.data.user.approved,
              company_id: response.data.user.company_id,
              company_name: response.data.user.company.company_name,
              area_id: response.data.user.area_id,
              area_name: response.data.user.area.area_name,
              site_id: response.data.user.site_id,
              site_name: response.data.user.site.site_name,
              token: response.data.token,
              auth: response.data.user.roles[0].name,
              authcode: response.data.user.roles[0].auth_level,
              password_change_requested: response.data.user.password_change_requested,
              groups: response.data.user.roles,
              is_active: response.data.user.approved,
              is_mup_customer: response.data.user.site.is_mup_customer
            };
            // store the user data in local storage
            localStorage.setItem('user', JSON.stringify(userObj));
            storeController.setUserAuthToken(response.data.token);
            this.$router.push('/');
          })
          .catch ((err) => {
            // login fail so let the user know
            this.$data.loginError = true;
          })
      }
    },
    showPasswordResetModal() {
      this.$data.activeStateForgottenPassword = true;
    },
    closePasswordResetModal() {
      this.$data.activeStateForgottenPassword = false;
    },
    getGlobalSettings() {
      let headerConfig = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'none',
        }
      }
      this.$http.get('settings', headerConfig)
        .then((response) => {
          response.data.settings.map((settingItem) => {
            switch (settingItem.setting_name) {
              case 'SAP_SUPPORT_PHONE': {
                this.$data.settingsPhone = settingItem.setting_value;
                break;
              }
              case 'SAP_SUPPORT_EMAIL': {
                this.$data.settingsEmail = settingItem.setting_value;
                break;
              }
              default: {
                break;
              }
            }        
          });
        })
        .catch ((err) => {
          console.error(err);
        });
    }
  }
}
</script>

<style scoped>
  .card.bg-SAP {
    background-color: rgb(247, 209, 74);
    color: #333333;
    border-color: rgb(179, 144, 21);
  }
  div.app-title {
    text-align: center;
    width: 100%;
    padding-bottom: 5px;
  }
  div.app-title h2 {
    display: inline;
  }
  div.app-title img {
    margin-top: -24px
  }
</style>
